"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Precision() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3612" id="precision-converting-solutions" className="dark relative min-h-screen w-full bg-background overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-screen">
        {}
        <div ref={leftRef} className={`relative w-full lg:w-[55%] h-[60vh] lg:h-screen overflow-hidden transition-all duration-[1200ms] ease-out ${leftVisible ? "opacity-100 scale-100" : "opacity-0 scale-[1.04]"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723303/img/industrial_precision_converter.png" alt="Precision die-cutting machinery in operation at Global Standard Technology facility" className="absolute inset-0 h-full w-full object-cover" loading="eager" decoding="async" />
          {}
          <div className="pointer-events-none absolute inset-0" style={{
          background: "radial-gradient(ellipse at center, transparent 55%, hsla(262, 48%, 10%, 0.4) 100%)"
        }} />

          {}
          <div className="absolute bottom-6 left-6 lg:bottom-10 lg:left-10 z-10">
            <p className="font-mono text-[10px] lg:text-xs uppercase tracking-[0.25em]" style={{
            color: "hsla(262, 48%, 90%, 0.8)"
          }}>
              — GST_NA / Industrial Excellence
            </p>
          </div>
        </div>

        {}
        <div ref={rightRef} className="relative w-full lg:w-[45%] flex items-center bg-background">
          <div className="w-full px-6 py-16 sm:px-10 lg:px-16 xl:px-20 lg:py-0">
            {}
            <div className={`flex items-center gap-4 mb-8 lg:mb-10 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: "100ms"
          }}>
              <span className="block h-px w-10 bg-primary/40" />
              <span className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-indigo-muted">
                Standard 01
              </span>
            </div>

            {}
            <h1 className={`font-default font-bold text-primary leading-[0.95] tracking-tight transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(4rem, 8vw, 7rem)",
            transitionDelay: "200ms"
          }}>
              <span className="block">Precision</span>
              <span className="relative inline-block">
                Converting.
                {}
                <svg aria-hidden="true" viewBox="0 0 240 12" preserveAspectRatio="none" className="absolute left-0 -bottom-2 w-[85%] h-2 text-primary/60">
                  <path d="M2 6 Q 20 1, 40 6 T 80 6 T 120 6 T 160 6 T 200 6 T 238 6" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
                </svg>
              </span>
            </h1>

            {}
            <p className={`mt-10 lg:mt-12 max-w-[380px] text-base sm:text-lg leading-relaxed text-indigo-muted font-default transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: "400ms"
          }}>
              Delivering customized die-cutting, slitting, and laminating services for industrial adhesives, films, and gaskets across North America.
            </p>

            {}
            <div className={`mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: "550ms"
          }}>
              <Button asChild size="lg" className="h-12 px-7 bg-primary text-white hover:bg-primary/90 font-default text-sm tracking-wide">
                <Link to="/ContactPage">Request a Quote</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-12 px-7 border-primary bg-transparent text-primary hover:bg-primary hover:text-white font-default text-sm tracking-wide">
                <Link to="/AboutUsPage">
                  Our Capabilities <ArrowRight className="ml-1 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="hidden lg:flex absolute bottom-10 right-8 xl:right-10 flex-col items-center gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.4em] text-indigo-muted" style={{
            writingMode: "vertical-rl"
          }}>
              Scroll
            </span>
            <span className="relative block h-16 w-px bg-primary/20 overflow-hidden">
              <span className="absolute left-0 top-0 block w-px bg-primary" style={{
              height: "40%",
              animation: "tidalScrollLine 2.2s ease-in-out infinite"
            }} />
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes tidalScrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(250%); }
        }
      `}</style>
    </section>;
}